import { render, staticRenderFns } from "./ServiceProducts.vue?vue&type=template&id=2f4f4216"
import script from "./ServiceProducts.vue?vue&type=script&lang=js"
export * from "./ServiceProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports